<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_Book_Title"><span><img alt="" id="TitleText_eBook" src="TitleText_eBook.jpg" style="max-width:100%; max-height:100%; "/></span></p>
<p class="P_WFP_By_Line__And__Bold" id="auto_bookmark_table_of_contents_1"><span>Edited by<br/>Bryan Thomas Schmidt</span></p>
<p class="P_WFP_Copyright_Center"><span>Kobo Edition – 2016</span></p>
<p class="P_WFP_Copyright_Center"><span>WordFire Press<br/>wordfirepress.com</span></p>
<p class="P_WFP_Copyright_Center"><span>ISBN: 978-1-61475-425-1</span></p>
<p class="P_WFP_Copyright_Center"><span>Copyright © 2016 Bryan Thomas Schmidt</span></p>
<p class="P_WFP_Copyright_Center"><span>Additional copyright information in <span href="#/section0026#Copyright" title="Link target outside of Sample">Copyright</span> section</span></p>
<p class="P_WFP_Copyright_left">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any electronic or mechanical means, including photocopying, recording or by any information storage and retrieval system, without the express written permission of the copyright holder, except where permitted by law. This novel is a work of fiction. Names, characters, places and incidents are either the product of the author’s imagination, or, if real, used fictitiously.</p>
<p class="P_WFP_Copyright_left">This book is licensed for your personal enjoyment only. This ebook may not be re-sold or given away to other people. If you would like to share this book with another person, please purchase an additional copy for each recipient. Thank you for respecting the hard work of this author.</p>
<p class="P_WFP_Copyright_Center"><span>Edited by Bryan Thomas Schmidt</span></p>
<p class="P_WFP_Copyright_Center"><span>Cover design by Duong Covers</span></p>
<p class="P_WFP_Copyright_Center"><span>Art Director by Kevin J. Anderson</span></p>
<p class="P_WFP_Copyright_Center"><span>Cover artwork images by Dollar Photo</span></p>
<p class="P_WFP_Copyright_Center"><span>Book Design by RuneWright, LLC<br/>www.RuneWright.com</span></p>
<p class="P_WFP_Copyright_Center"><span>Kevin J. Anderson &amp; Rebecca Moesta, Publishers</span></p>
<p class="P_WFP_Copyright_Center"><span>Published by<br/>WordFire Press, an imprint of<br/>WordFire, Inc.<br/>PO Box 1840<br/>Monument, CO 80132</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?3f11fa3f